import YQuillEditor from '@/components/editor/QuillEditor'
/** 编辑器混合器，兼容新老版本编辑器
 * 使用注意要点
 *  1. xheditor的id必须为 txtbody
 *  2. quill的ref必须为 myQuillEditor
 *  3. quill的绑定数据必须是content
 *
 * 混合器功能
 * 1. mounted / destroyed 加载/销毁 xheditor
 * 2. computed 获取 兼容编辑器实例
 * 3. 开放 getContent 、setContent 兼容方法
 * 4. 增加新老切换识别功能 cookie oldEditor = 1 使用老的，否则使用新的
 * 5. 开放计算属性useOldEditor判断是否使用老编辑器
 */

const EditorMixin = {
  data () {
    return {
      // 编辑器
      content: ''
    }
  },
  methods: {
    getContent () {
      return this.content
    },

    setContent (content) {
      this.editor.deleteText(0, this.editor.getLength(), 'user')
      this.editor.clipboard.dangerouslyPasteHTML(0, content)
    }
  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    }
  },
  components: {
    YQuillEditor
  }
}

export default EditorMixin
